document.body.classList.add('infinite-scroll-active');

(function () {
  const settings = JSON.parse(
    document.querySelector('[data-collection-settings]').textContent
  );

  if (settings.paginationType !== 'infinite-scroll') return;
  if (!settings.nextPage) return;

  const grid = document.getElementById('main-collection-product-grid');
  const trigger = document.getElementById('infinite-scroll-trigger');
  const paginationBottom = document.getElementById('pagination-bottom-container');

  if (!grid || !trigger) return;

  let loading = false;
  let currentPage = parseInt(settings.currentPage, 10);

  // Mevcut sayfalama linklerini gizle (trigger hariç)
  if (paginationBottom) {
    const paginationLinks = paginationBottom.querySelector('.pagination');
    if (paginationLinks) paginationLinks.style.display = 'none';
  }

  // Yükleniyor göstergesi
  const spinner = document.createElement('div');
  spinner.id = 'infinite-scroll-spinner';
  spinner.innerHTML = '<div style="text-align:center;padding:20px;display:none;"><span>Yükleniyor...</span></div>';
  trigger.parentNode.insertBefore(spinner, trigger);

  function getNextPageUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('page', currentPage + 1);
    return url.toString();
  }

  // Kalan ürün sayısını hesapla
  const remaining = document.getElementById('infinite-scroll-remaining');

  function loadMore() {
    if (loading) return;
    loading = true;
    spinner.querySelector('div').style.display = 'block';

    fetch(getNextPageUrl())
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelectorAll('#main-collection-product-grid > *:not(.collection-tool-bar)');
        
        newProducts.forEach((el) => grid.appendChild(el));
        currentPage++;

        // Kalan ürün sayısını hesapla ve göster
        if (remaining) {
        const loaded = currentPage * parseInt(settings.pageSize, 10);
        const total = parseInt(settings.totalItems, 10);
        const left = Math.max(total - loaded, 0);
        if (left > 0) {
            remaining.style.display = 'block';
            remaining.textContent = left + ' ürün';
        } else {
            remaining.style.display = 'none';
        }
        }

        
        // "X arası gösteriliyor" yazısını güncelle
        const showingText = document.getElementById('showing-items-text');
        if (showingText) {
        const newTo = (currentPage) * parseInt(settings.pageSize || 36, 10);
        const total = showingText.textContent.match(/\d+/g)?.[0] || '';
        // Mevcut metni güncelle — "to" değerini artır
        showingText.textContent = showingText.textContent.replace(
            /1 - \d+/,
            '1 - ' + Math.min(newTo, parseInt(total, 10))
        );
        }


        // Sonraki sayfa var mı kontrol et
        const newSettings = JSON.parse(
          doc.querySelector('[data-collection-settings]').textContent
        );

        if (!newSettings.nextPage) {
          observer.disconnect();
          trigger.remove();
        }

        spinner.querySelector('div').style.display = 'none';
        loading = false;
      })
      .catch(() => {
        loading = false;
        spinner.querySelector('div').style.display = 'none';
      });

  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadMore();
      });
    },
    { rootMargin: '200px' }
  );

  observer.observe(trigger);
})();
